import { useNavigate } from 'react-router-dom';

import { MainContent } from './components/MainContent';

import { NavBar } from '@/components/Navbar';
import ROUTES from '@/router/routes';

export const NotificationsMobile = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <NavBar
        mobile={{
          leftContent: {
            backAction: () => navigate(ROUTES.summary),
          },
          centerContent: {
            title: 'Notificaciones',
          },
        }}
      >
        <div className="flex-1 bg-white flex flex-col">
          <MainContent />
        </div>
      </NavBar>
    </div>
  );
};

export default NotificationsMobile;
